import { Menu, Transition } from "@headlessui/react";
import {
  DotsHorizontalIcon,
  FlagIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/solid";
import React, { Fragment, useContext } from "react";
import { firebase } from "../constants/firebase";
import { PopupContext } from "../containers/Popup";

export const CommentActions = ({
  myPost,
  commentId,
  replyId,
  isReply = false,
  setEditMode,
}) => {
  const db = firebase.firestore();
  const { setShowModal } = useContext(PopupContext);

  const deletePost = (e) => {
    if (isReply) {
      db.doc(`comments/${commentId}`)
        .get()
        .then((doc) => {
          const comment = doc.data();
          // Remove reply reference from comment replies
          doc.ref
            .update({
              replies: comment.replies.filter((reply) => reply.id !== replyId),
            })
            .then(() => {
              // Delete Reply
              db.doc(`replies/${replyId}`).delete();
            });
        });
    } else {
      db.doc(`comments/${commentId}`)
        .get()
        .then((doc) => {
          const comment = doc.data();
          // Delete replies
          const snapshot = comment.replies;
          const batchSize = snapshot.length;

          if (batchSize === 0) {
            // When there are no documents left, we are done
            return doc;
          }

          // Delete documents in a batch
          const batch = db.batch();
          snapshot.forEach((d) => {
            batch.delete(d);
          });
          batch.commit();
          return doc;
        })
        .then((doc) => {
          // Delete comment
          doc.ref.delete();
        });
    }
  };

  const myPostActions = [
    {
      title: "Edit",
      textColor: "white",
      icon: <PencilIcon className="w-5 h-5 text-white" />,
      onClick: (e) => setEditMode(true),
    },
    {
      title: "Delete",
      textColor: "red-400",
      icon: <TrashIcon className="w-5 h-5 text-red-400" />,
      onClick: deletePost,
    },
  ];

  const commentActions = [
    {
      title: "Report",
      textColor: "red-400",
      icon: <FlagIcon className="w-5 h-5 text-red-400" />,
      onClick: (e) =>
        setShowModal({ name: "report", detail: { commentId, replyId } }),
    },
  ];

  const actions = myPost ? myPostActions : commentActions;

  return (
    <Menu>
      <Menu.Button>
        <DotsHorizontalIcon className="w-5 h-5 text-white" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-2 top-4 w-40 mt-2 origin-top-right bg-gray-700 divide-y divide-gray-100 border border-gray-500 rounded-md shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-1 py-1 ">
            {actions.map((action) => {
              return (
                <Menu.Item key={action.title}>
                  {({ active }) => (
                    <button
                      type="button"
                      className={`hover:bg-gray-600 text-${action.textColor} font-bold group flex rounded-md items-center w-full px-2 py-2 text-sm `}
                      onClick={action.onClick}
                    >
                      {action.icon}
                      <span className="ml-2">{action.title}</span>
                    </button>
                  )}
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
